import { Anchor } from "@core/components/cta/Anchor";
import { StIcon } from "@core/components/icons";
import { classNames } from "@core/lib/classNames";
import { A } from "@solidjs/router";
import { TbMapPinX } from "solid-icons/tb";
import { Show } from "solid-js";
import styles from "./NotFoundScreen.module.css";

interface Props {
  modifier?: "full-screen";
}

export const NotFoundScreen = (props: Props) => {
  return (
    <div
      class={classNames(
        styles["not-found-screen"],
        props.modifier === "full-screen" ? styles["not-found-screen--full-screen"] : "",
      )}
    >
      <div class={styles["not-found-screen__container"]}>
        <div class={styles["not-found-screen__header"]}>
          <StIcon icon={TbMapPinX} size="5rem" class={styles["not-found-screen__icon"]} />
        </div>
        <div class={styles["not-found-screen__content"]}>
          <p class={styles["not-found-screen__title"]}>Unauthorized or Not Found.</p>
          <br />
          <p class={styles["not-found-screen__subtitle"]}>
            You may need to{" "}
            <A href="/auth/signup" style={{ color: "var(--color-on-background-primary)" }}>
              sign up
            </A>{" "}
            or{" "}
            <A href="/auth/login" style={{ color: "var(--color-on-background-primary)" }}>
              log in
            </A>{" "}
            to access this page.
          </p>
        </div>

        <Show when={props.modifier === "full-screen"}>
          <div class={styles["not-found-screen__actions"]}>
            <Anchor
              data-test-id="404-return-to-homepage"
              target="_self"
              href="/"
              accessibleSuffix="As this page is missing"
              label="Return to homepage"
            />
          </div>
        </Show>
      </div>
    </div>
  );
};
